import * as Yup from "yup";
const CouponInitialValues = {
  title: "",
  discount: "",
  limit: "",
  code: "",
  description: "",
  oneTimeUser: false,
};
const CouponValidationSchema = Yup.object().shape({
  title: Yup.string().trim().required("Title is required*"),
  discount: Yup.string().trim().required("Discount is required*"),
  limit: Yup.string().trim().required("Limit is required*"),
  code: Yup.string().trim().required("Code is required*"),
  description: Yup.string().trim(),
  oneTimeUser: Yup.boolean(),
});

export { CouponInitialValues, CouponValidationSchema };
